<template>
  <!-- <div class=""> -->
    <transition name="page">
      <div v-if="musicIsShown" class="page-site">
        <router-link to="/" class="icon close">
          <Close></Close>
        </router-link>
        <div class="page-container">
          <div class="content-wrapper">
            <div class="soundcloud-wrapper">
              <div class="soundcloud-ctnr">
                <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/357448997&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
              </div>
            </div>
            <div class="soundcloud-wrapper">
              <div class="soundcloud-ctnr">
                <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/357447180&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
              </div>
            </div>
            <div class="soundcloud-wrapper">
              <div class="soundcloud-ctnr">
                <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/357447016&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
              </div>
            </div>
            <div class="soundcloud-wrapper">
              <div class="soundcloud-ctnr">
                <iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/357445554&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  <!-- </div> -->


</template>

<script>
import Close from '../assets/icons/close.svg'
import {bus} from '../main'

export default {
  name: 'music',
  data () {
    return {
      musicIsShown: false
    }
  },
  components: {
    Close
  },
  created() {
    this.musicIsShown = true;
    bus.$emit('navHide');
    bus.$emit('navHide');
  },
  mounted() {
    console.log('mounted')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Music.vue